import { gql } from '@apollo/client/core'

export const PRICE_FRAGMENT = gql`
  fragment PriceFragment on MoneyV2 {
    amount
    currencyCode
  }
`

export const PRODUCT_VARIANT_FRAGMENT = gql`
  fragment ProductVariantFragment on ProductVariant {
    id
    title
    availableForSale
    quantityAvailable
    image {
      src
    }
    compareAtPrice {
      amount
    }
    price {
      ...PriceFragment
    }
    compareAtPrice {
      ...PriceFragment
    }
    selectedOptions {
      name
      value
    }
  }

  ${PRICE_FRAGMENT}
`
